import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from './store'
import './plugins'
import "./registerServiceWorker"
import VueTour from "vue-tour";
require('vue-tour/dist/vue-tour.css')
Vue.use(VueTour)
import { BootstrapVue, IconsPlugin } from 'bootstrap-vue'
Vue.use(BootstrapVue);
Vue.use(IconsPlugin);
import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'
import "./assets/css/mdi/css/materialdesignicons.min.css"
import './assets/css/theme.css'
import './assets/css/fonts/kgk/style.css'
import './assets/css/dashboard.css'
import './assets/css/datatables.css'
import utils_mixin from "./mixins/utils";
import am from "./mixins/auth-mixin";
import core_mixin from "./mixins/core-mixin";
import { _ } from "core-js";
var auth_mixin = am.methods;
Vue.config.productionTip = false;
global.jQuery = require('jquery');
var $ = global.jQuery;
window.$ = $;
window._ = require('lodash');
if (localStorage.getItem('me_info_') !== null) {
  setInterval(function () {
    localStorage.removeItem('me_info_');
  }, 604800000)
}

// GET AND STORE PHONE PREFIXES IN CACHE
if(utils_mixin.methods.utils_get_cookies("phone_prefixes_2024")) {
  store.state.settings.phone_prefixes = JSON.parse(utils_mixin.methods.utils_get_cookies("phone_prefixes_2024"))
} else {
  global.jQuery.getJSON('https://chat.mtn.bj/7k8e1/prefixes').then((data) => {
    store.state.settings.phone_prefixes = data
    utils_mixin.methods.utils_set_cookies("phone_prefixes_2024", JSON.stringify(data), 60*1);
  })
}

router.beforeEach(async function (to, from, next) {
  window.scrollTo(0, 0)
  const have_session = await auth_mixin.init_session()
  if (have_session) {
    if (store.state.app_is_ready == true && !_.isNull(store.state.configs)) {
      next()
    } else {
      next()
      await auth_mixin.init_app();
    }
  }
});
new Vue({
  mixins: [Vue.mixin(utils_mixin), Vue.mixin(am), Vue.mixin(core_mixin)],
  router,
  store,
  render: h => h(App)
}).$mount("#app");